import React from 'react';
import { Layout, Typography } from 'antd';
import { motion } from 'framer-motion';
import { standardVariants } from '../utils/useAnimations';
import { AccessibleButton } from '../components/AccessibleButton';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export const NotFoundPage: React.FC = () => {
  return (
    <Content role="main" aria-label="Page non trouvée">
      <section className="max-w-[1440px] mx-auto px-20 py-40 text-center min-h-[80vh] flex flex-col justify-center">
        <motion.div
          variants={standardVariants}
          initial="hidden"
          animate="visible"
          className="max-w-2xl mx-auto"
        >
          <Title level={1} className="!text-6xl !font-bold !mb-4 !text-primary-600">
            404
          </Title>
          
          <Title level={2} className="!text-3xl !font-bold !mb-6">
            Page non trouvée
          </Title>
          
          <Paragraph className="!text-lg !text-neutral-600 !mb-8">
            Désolé, la page que vous recherchez n'existe pas ou a été déplacée. Retournez à l'accueil pour découvrir nos parcours de sensibilisation aux handicaps dans le numérique.
          </Paragraph>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <AccessibleButton 
              type="primary"
              href="/"
              isLink={true}
              ariaLabelKey="navigation.backToHome"
            >
              Retour à l'accueil
            </AccessibleButton>
            
            <AccessibleButton 
              type="secondary"
              href="/#parcours"
              isLink={true}
              ariaLabelKey="buttons.startAdventure"
            >
              Découvrir les parcours
            </AccessibleButton>
          </div>
        </motion.div>
      </section>
    </Content>
  );
};